<ng-container *ngIf="headers$ | async as headers">
  <ng-container *ngIf="comparedData$ | async as data">
    <table mat-table [dataSource]="data" class="mat-elevation-z1">
      <!-- Label Column -->
      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>{{ headers.labelHeader }}</th>
        <td mat-cell *matCellDef="let row">{{ row.label }}</td>
      </ng-container>

      <!-- First Data Point Column -->
      <ng-container matColumnDef="firstDataPoint">
        <th mat-header-cell *matHeaderCellDef>{{ headers.firstDataHeader }}</th>
        <td mat-cell *matCellDef="let row">{{ row.firstDataPoint }}</td>
      </ng-container>

      <!-- Second Data Point Column -->
      <ng-container matColumnDef="secondDataPoint">
        <th mat-header-cell *matHeaderCellDef>{{ headers.secondDataHeader }}</th>
        <td mat-cell *matCellDef="let row">{{ row.secondDataPoint }}</td>
      </ng-container>

      <!-- Header Row -->
      <tr mat-header-row *matHeaderRowDef="['label', 'firstDataPoint', 'secondDataPoint']"></tr>

      <!-- Data Rows -->
      <tr
        mat-row
        *matRowDef="let row; columns: ['label', 'firstDataPoint', 'secondDataPoint']"
        [ngClass]="{
          'match-row': row.isEqual,
          'mismatch-row': !row.isEqual && !row.warnOnly,
          'warn-row': !row.isEqual && (row.warnOnly || row.isInDeviationRange)
        }"></tr>
    </table>
  </ng-container>
</ng-container>
